import AppContainer from "../basicLayout/AppContainer";
export default [
	{
		path: "/sys",
		name: "sys_management",
		component: AppContainer,
		meta: {
			title: "系统管理",
		},
		children: [
			{
				path: "menu",
				name: "Menu",
				meta: {
					title: "菜单管理",
				},
				component: (resolve) =>
					require(["@/views/system/sys/menu/index.vue"], resolve),
			},
			{
				path: "org",
				name: "Dept",
				meta: {
					title: "部门管理",
				},
				component: (resolve) =>
					require(["@/views/system/sys/org/index.vue"], resolve),
			},
			{
				path: "role",
				meta: {
					title: "角色管理",
				},
				name: "Role",
				component: (resolve) =>
					require(["@/views/system/sys/role/index.vue"], resolve),
			},
			
			{
				path: "user",
				meta: {
					title: "用户管理",
				},
				name: "User",
				component: (resolve) =>
					require(["@/views/system/sys/user/index.vue"], resolve),
			},
			{
				path: "post",
				meta: {
					title: "岗位管理",
				},
				name: "Post",
				component: (resolve) =>
					require(["@/views/system/sys/post/index.vue"], resolve),
			},
			{
				path: 'dict',
				meta:{
					title:"字典管理",
				},
				name: 'Dict',
				component:resolve => require(["@/views/system/sys/dict/index.vue"], resolve)
			},
			{
				path: 'application',
				meta:{
					title:"应用管理",
				},
				name: 'Application',
				component:resolve => require(["@/views/system/sys/application/index.vue"], resolve)
			}
		],
	},
	//日志管理
	{
		path: "/log",
		name: "log_management",
		component: AppContainer,
		meta: {
			title: "日志管理",
		},
		children: [
			{
				path: 'logininfor',
				meta:{
					title:"登录日志",
				},
				name: 'Logininfor',
				component:resolve => require(["@/views/system/log/logininfor.vue"], resolve)
			},
			{
				path: 'operlog',
				meta:{
					title:"操作日志",
				},
				name: 'Operlog',
				component:resolve => require(["@/views/system/log/operlog.vue"], resolve)
			},
			
		],
	},
];
